import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Link, Card, Grid, Avatar, Typography, CardContent, Chip } from '@mui/material';
import Icofont from "react-icofont";
import { t } from 'i18next';
import SvgIconStyle from '../../../components/SvgIconStyle';
import Iconify from '../../../components/Iconify';



// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')({
  position: 'relative',
  paddingTop: 'calc(100% * 3 / 4)',
});

const TitleStyle = styled(Link)({
  height: 44,
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const AvatarStyle = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: 32,
  height: 32,
  position: 'absolute',
  left: theme.spacing(3),
  bottom: theme.spacing(-2),
}));

const InfoStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled,
}));

const CoverImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

AnnouncementCard.propTypes = {
  announcement: PropTypes.object.isRequired,
  index: PropTypes.number,
};

export default function AnnouncementCard({ announcement, index }) {
  const createdAt = announcement.created_at;
  const { body,image,hashid,title,url,active } = announcement;
  const latestAnnouncementLarge = false;
  const latestAnnouncement = false;

  const EVENT_INFO = [
    // { number: comment, icon: 'eva:message-circle-fill' },
    // { number: view, icon: 'eva:eye-fill' },
    // { number: share, icon: 'eva:share-fill' },
  ];

  return (
      <Grid item xs={12} sm={latestAnnouncementLarge ? 12 : 6} md={latestAnnouncementLarge ? 6 : 3}>
        <Card sx={{ position: 'relative' }}>
          <CardMediaStyle
              sx={{
                ...((latestAnnouncementLarge || latestAnnouncement) && {
                  pt: 'calc(100% * 4 / 3)',
                  '&:after': {
                    top: 0,
                    content: "''",
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
                  },
                }),
                ...(latestAnnouncementLarge && {
                  pt: {
                    xs: 'calc(100% * 4 / 3)',
                    sm: 'calc(100% * 3 / 4.66)',
                  },
                }),
              }}
          >
            <SvgIconStyle
                color="paper"
                src="/static/icons/shape-avatar.svg"
                sx={{
                  width: 80,
                  height: 36,
                  zIndex: 9,
                  bottom: -15,
                  position: 'absolute',
                  color: 'background.paper',
                  ...((latestAnnouncementLarge || latestAnnouncement) && { display: 'none' }),
                }}
            />


            <CoverImgStyle alt={title} src={image} />
          </CardMediaStyle>

          <CardContent
              sx={{
                pt: 4,
                ...((latestAnnouncementLarge || latestAnnouncement) && {
                  bottom: 0,
                  width: '100%',
                  position: 'absolute',
                }),
              }}
          >
              <Typography
                  gutterBottom
                  variant="body2"
                  sx={{ color: 'text.disabled', display: 'block', textAlign: 'right', textDecoration: 'none' }}
                  component={RouterLink}
                  to={`/dashboard/announcement/edit/${hashid}`}
              >
                  <Icofont icon="edit" />
              </Typography>
            <TitleStyle
                to={`/dashboard/announcement/edit/${hashid}`}
                color="inherit"
                variant="subtitle2"
                underline="hover"
                component={RouterLink}
                sx={{
                  ...(latestAnnouncementLarge && { typography: 'h5', height: 60 }),
                  ...((latestAnnouncementLarge || latestAnnouncement) && {
                    color: 'common.white',
                  }),
                }}
            >
              <span style={{marginRight: '15px'}}>{announcement.title}</span>
              {announcement.active ?  <Chip label={t('active')} color="success" variant="outlined" /> : <Chip label={t('inactive')} color="warning" variant="outlined" />}
             
            </TitleStyle>

            <InfoStyle>
              {EVENT_INFO.map((info, index) => (
                  <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        ml: index === 0 ? 0 : 1.5,
                        ...((latestAnnouncementLarge || latestAnnouncement) && {
                          color: 'grey.500',
                        }),
                      }}
                  >
                    <Iconify icon={info.icon} sx={{ width: 16, height: 16, mr: 0.5 }} />

                  </Box>
              ))}
            </InfoStyle>
          </CardContent>
        </Card>
      </Grid>
  );
}
